export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: ""
        };
      },
      description: "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info"
    },
    modelValue: {
      default: false
    },
    newModule: {
      default: false
    }
  },
  data() {
    return {
      showCollapse: false
    };
  },
  emits: ["update:modelValue", "click-menu"],
  watch: {
    modelValue(val) {
      this.showCollapse = val;
    },
    showCollapse(val, oldVal) {
      if (val !== oldVal) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    clickRefresh(path) {
      if (this.$router.currentRoute.fullPath === path) {
        this.$store.commit("common/setPageLoad", new Date().getTime());
      }
    }
  }
};